import { Button, Toast, Modal } from "antd-mobile";
import React, { Component } from "react";
import styles from './index.less';
import successImg from '../../public/result_success.png';
import arrowImg from '../../public/icon-arrow-list@2x.png';
import failImg from '../../public/icon-result-fall@2x.png';
import { selectTruckBrokerOrder, confirmOrder, refuseOrder } from '../../services/order';
export default class AcceptOrder extends Component {

  state = {
    key: null,
    data: null,
    isShowOperResult: false,
  }

  componentDidMount() {
    this.getOrder();
  }

  //取key
  getKey(){
    let search = this.props.location.search;
    if(!search){
      return '';
    }
    search = search.replace(/\?/, '');
    const arr = search.split('key=');
    const key = arr[1];
    return key;
  }

  //查询订单
  getOrder() {
    const key = this.getKey();
    this.setState({key:key});
    selectTruckBrokerOrder({key}).then(res => {
      if (res.code === 0) {
        this.setState({ data: res.data });
      } else {
        Toast.fail(res.msg);
      }
    });
  }

  // 接单
  confirm() {
    confirmOrder({key:this.state.key}).then(res => {
      if (res.code === 0) {
        // 展示已接单操作结果
        this.setState({isShowOperResult: true, isAccept: 1});
        this.renderResult(1);
      } else {
        Toast.fail(res.msg);
      }
    })
  }

  //拒单
  refuse() {
    refuseOrder({ key: this.state.key }).then(res => {
      if (res.code === 0) {
        // 展示已拒单操作结果
        this.setState({isShowOperResult: true, isAccept: 0});
        this.renderResult(0);
      } else {
        Toast.fail(res.msg);
      }
    })
  }

  showAlter = (type) => {
    if (type === 1) {
      Modal.alert('', '确定接单?', [{ text: '取消' }, { text: '确定', onPress: () => { this.confirm() } }]);
    } else {
      Modal.alert('', '确定拒绝?', [{ text: '取消' }, { text: '确定', onPress: () => { this.refuse() } }]);
    }
  }

  goodsInfo(item) {
    var tempArray = [];
    if (item.price) {
      var initialPrice = item.price.toFixed(2) + '元/' + item.unit;
      tempArray.push(initialPrice);
    }
    if (item.quantity) {
      var quantity = item.quantity + item.unit;
      tempArray.push(quantity);
    }
    if (item.goodsType) {
      tempArray.push(item.goodsType)
    }
    return tempArray.join('，');
  }

  renderAcceptOrder() {
    const { data } = this.state;
    if (data && data.acceptStatus === 0) {
      return (
        <div className={styles.box}>
          <div className={styles.titleDiv}><span className={styles.title}>运单编号：</span><span className={styles.subText}>{data.outerOrderNo}</span></div>
          <div className={styles.addressInfo}>
            <span>{`${data.fromCity}${data.fromRegion}`}</span>
            <img src={arrowImg} alt="" className={styles.arrow} />
            <span>{`${data.toCity}${data.toRegion}`}</span>
          </div>
          <div className={styles.goodInfo}>
            <div className={styles.titleDiv}><span>货物信息：</span><span>{this.goodsInfo(data)}</span></div>
            <div className={styles.titleDiv}><span>总运费：</span><span>{data.driverTotalFreight ? `${data.driverTotalFreight.toFixed(2)}元` : ''}</span></div>
            <div className={styles.titleDiv}><span>发货方：</span><span>{data.ownerName}</span></div>
          </div>
          <div className={styles.bottomView}>
            <Button className={styles.button} onClick={() => this.showAlter(0)}>拒单</Button>
            <Button className={styles.buttonBule} onClick={() => this.showAlter(1)}>接单</Button>
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.success}>
          <img className={styles.successImg} src={failImg} alt="" />
          <span className={styles.successText}>已无待接单信息</span>
          <span className={styles.hint}>该运单可能已被接单或关闭</span>
        </div>
      )
    }
  }

  renderResult() {
    const { isAccept } = this.state;
    return (
      <div className={styles.success}>
        <img className={styles.successImg} src={successImg} alt="" />
        <span className={styles.successText}>{isAccept === 1 ? '接单成功' : '已拒绝接单'}</span>
      </div>
    );
  }

  render() {
    const {isShowOperResult } = this.state;
    return (
      <div className={styles.content}>
        {isShowOperResult ? this.renderResult() : this.renderAcceptOrder()}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/routes/acceptOrder/index.js